module.exports = __webpack_public_path__ + "static/media/text-background-1.587f3dc0.png";